<template>
  <!-- Request cards data -->
  <GetterWrapper id="store" :api-load="apiLoad" @data="onData">
    <div class="store row align-center">
      <ViewHeader :hasBack="true" urlBack="card-item" :title="text" :icon="icon" :backgroundIcon="background"/>
      <div class="columns small-12 medium-10 large-8" v-if="card">
        <ViewDetails v-if="isFLType"
                     content="Votre carte cadeau est exclusivement valable dans tous les magasins de votre centre commercial Buld'air Shopping Centre de Vedène."/>
        <ViewDetails v-else-if="isCVType" :content="$t('card.store.cvType.intro')"/>
        <ViewDetails v-else-if="isCCType" :content="$t('card.store.ccType.intro')"/>
        <ViewDetails v-else :content="$t('card.store.intro', {value : hasXpay  ? $t('card.store.introXpay') : ''} )"/>

        <!--            <div class="store-image"></div> -->

        <div v-if="isFLType" class="fl-type">
          <p>Pour utiliser votre carte cadeau en magasin, c’est facile ! Ajoutez votre carte cadeau dans l’application
            de paiement de votre téléphone (Google Pay ou Apple Pay) et réglez vos achats en posant votre téléphone
            déverrouillé sur le terminal de paiement du magasin.</p>
          <p>Si le solde de votre carte cadeau n’est pas suffisant, complétez votre paiement en caisse avec un autre
            moyen de paiement.</p>
          <p>C’est simple, sécurisé et sans limite de montant !</p>
          <div class="text-center">
            <button class="button" @click="goToBuldair">Découvrir les magasins Buldair Shopping Centre</button>
          </div>
        </div>

        <div v-else>

          <p v-if="isCVType"> {{ $t('card.store.cvType.subintro') }}</p>
          <p v-else-if="isCCType">{{ $t('card.store.ccType.subintro') }}</p>
          <p v-else>{{ $t('card.store.subintro') }}</p>

          <ul v-if="isCVType && card && $tm('card.store.cvType.list').length ">
            <li v-for="(item, index) in  $tm('card.store.cvType.list')" :class="item.length" :key="'list-'+index">
              {{ item }}
            </li>
          </ul>
          <ul v-else-if="isCCType && card && $tm('card.store.ccType.list').length ">
            <li v-for="(item, index) in  $tm('card.store.ccType.list')" :class="item.length" :key="'list-'+index">
              {{ item }}
            </li>
          </ul>
          <ul v-else-if="!isCVType && !isCCType && card && $tm('card.store.sublist').length">
            <li v-for="(item, index) in  $tm('card.store.sublist')"
                :class="item.length &&  itemCSEvisible(index) ? '' : 'is-hidden'" :key="'list-'+index">{{ item }}
            </li>
          </ul>

          <HighlightedBloc v-if="!isCVType && !isCCType" :texts="$tm('card.store.highlight')" :onClick="goToBanners"/>

          <div class="store-help-bloc" :class="itemXpayVisible(index) ? '' : 'is-hidden'"
               v-for="(bloc, index) in $tm('card.store.blocs')" :key="'store-bloc-' + index">
            <ActionText class="help-subject" :icon="'sofont-arrow-down' + (currentHelp === index ? ' is-up' : '')"
                        :isTitle="true" :text="bloc.title" v-on:action="openHelp(index)"/>
            <p v-if="currentHelp === index && bloc.text" v-html="bloc.text" class="column"></p>
            <ul class="step-list column" v-if="currentHelp === index && bloc.list">
              <li class="step-item" v-for="item, index in bloc.list" :key="'list-'+index">
                <div class="step-icon">
                  <span>{{ index + 1 }}</span>
                </div>
                <span>{{ item }}</span>
              </li>
            </ul>
            <div v-if="currentHelp === index && bloc.listend" class="column text-center">
              <div class="step-item step-center last-step">
                <div class="step-icon"><i class="sofont sofont-check"></i></div>
                <p><strong v-html="bloc.listend"></strong></p>
              </div>
            </div>

            <HighlightedBloc v-if="currentHelp === index && bloc.highlight" :texts="formatText(bloc.highlight)"
                             :onClick="goToBalance"/>
            <div v-if=" currentHelp === 1 && index === 1" class="xpay-image"></div>
            <div class="text-center">
              <button v-if="currentHelp === 1 && index === 1" class="button" @click="openXpay">
                {{ bloc.button }}
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </GetterWrapper>
</template>

<script src="./store.js"></script>

<style lang="scss" src="./store.scss">
</style>
